<template>
  <div>
    <l-marker :lat-lng="getLatLng(safeRecord)">
      <l-tooltip>
        <p><b>Vehicle - {{ vehicle?.name }}</b></p>
        <p><b>Latitude:</b> {{ getLatLng(safeRecord)[0] }}</p>
        <p><b>Longitude:</b> {{ getLatLng(safeRecord)[1] }}</p>
        <p v-if="vehicle.fields.headingKey"><b>Heading:</b> {{ safeRecord?.[vehicle.fields.headingKey] ?? 0 }}º</p>
      </l-tooltip>

      <l-icon :icon-size="shouldShow ? [vehicle.size, vehicle.size] : [0, 0]"
        :class-name="`boat-${vehicle?.name}-${mission.name}-icon boat`" class="boat">
        <template v-slot:default>


          <div class="wind-card">
            <Icon :icon="vehicle.icon" :height="shouldShow ? vehicle.size : 0" :width="shouldShow ? vehicle.size : 0"
              :color="vehicle?.boat_mark_color" :rotate="safeRecord?.[vehicle.fields.headingKey] ?? 0">
            </Icon>

            <svg
              v-if="show_wind && shouldShow && safeRecord && vehicle.fields?.wind_angleKey && vehicle.fields?.wind_speedKey && vehicle.fields?.headingKey"
              :style="{
                position: 'absolute',
                transform: `translate(${windPosition.x}px, ${windPosition.y}px) rotate(${windPosition.angle}deg)`,
                transformOrigin: 'center'
              }" class="wind_svg" viewBox="0 0 12.79 27.15">

              <path v-for="index in getTriangles(safeRecord?.[vehicle.fields.wind_speedKey])" :key="index"
                class="wind_svg_velocity_triangle" d="M27.47,1.13c.16.17-11.8,8.65-11.8,8.65V6.61S27.3,1,27.47,1.13Z"
                :transform="`translate(-15.17 ${index * 4 - 4})`" />

              <line v-for="index in getLargeLines(safeRecord?.[vehicle.fields.wind_speedKey])" :key="index"
                class="wind_svg_velocity_long_line" x1="0.26" y1="6.61" x2="12.18" y2="0.66"
                :transform="`translate(0 ${index * 2 - 2 + Math.floor(safeRecord?.[vehicle.fields.wind_speedKey] / 50) * 4.3})`" />

              <line v-for="index in getShortLines(safeRecord?.[vehicle.fields.wind_speedKey])" :key="index"
                class="wind_svg_velocity_short_line" x1="0.26" y1="6.61" x2="6.33" y2="3.58"
                :transform="`translate(0 ${index * 2 - 2 + Math.floor(safeRecord?.[vehicle.fields.wind_speedKey] / 50) * 4.3 + Math.floor((safeRecord?.[vehicle.fields.wind_speedKey] % 50) / 10) * 2})`" />

              <path class="wind_svg_angle_line" :style="{ fill: '#fff', stroke: '#1d1d1b' }" d="M16.17,6.81v21"
                transform="translate(-15.17 -0.63)" />
            </svg>
          </div>


        </template>
      </l-icon>
    </l-marker>



    <l-polyline v-if="show_boats_route && vehicle?.latLngs?.length > 0" :lat-lngs="vehicle.latLngs.slice(0, P + 1)"
      :key="`route-${mission.id}-${vehicle.id}`" class-name="route"
      :color="vehicle.route_color == '' ? '#002885' : vehicle?.route_color" dashArray="5,10" />

    <template>

      <l-marker v-if="vehicle.latLngsWaypoints.length != 0" v-for="(waypoint, index) in vehicle.latLngsWaypoints[W]"
        :lat-lng="waypoint ?? []" :key="`waypoint-${mission.id}-${vehicle.id}-${index}`" class-name="waypoints">
        <l-tooltip>
          <p><b>Waypoint - {{ index }} -</b></p>
          <p v-if="index === 0">'Return to home' waypoint</p>
          <p><b>Latitude :</b> {{ waypoint[0] }}</p>
          <p><b>Longitude :</b> {{ waypoint[1] }}</p>
        </l-tooltip>

        <l-icon :iconSize="[70, 70]" :class-name="show_waypoints && shouldShow ? 'waypoints' : 'display-none'">
          <v-icon :color="index === 0 ? hexOpposite(vehicle?.boat_waypoint_color) : vehicle?.boat_waypoint_color"
            size="50">mdi-map-marker</v-icon>
        </l-icon>
      </l-marker>




      <l-polyline ref="polylineRef" class-name="polyline-waypoint"
        :lat-lngs="show_waypoints && shouldShow ? polylineWaypoints : []"
        :color="vehicle.boat_waypoint_color == '' ? '#002885' : vehicle.boat_waypoint_color" dashArray="2,10"
        line-cap="butt">
      </l-polyline>



    </template>

    <template v-if="
      safeRecord &&
      vehicle.fields?.wp_latitudeKey &&
      vehicle.fields?.wp_longitudeKey &&
      safeRecord?.[vehicle.fields.wp_latitudeKey] &&
      safeRecord?.[vehicle.fields.wp_longitudeKey]
    ">

      <l-marker :key="`next-waypoint-${mission.id}-${vehicle.id}`"
        :lat-lng="[safeRecord?.[vehicle.fields.wp_latitudeKey], safeRecord?.[vehicle.fields.wp_longitudeKey]]">
        <l-tooltip>
          <p><b>Active Waypoint</b></p>
          <p><b>Latitude :</b> {{ safeRecord?.[vehicle.fields.wp_latitudeKey] }}</p>
          <p><b>Longitude :</b> {{ safeRecord?.[vehicle.fields.wp_longitudeKey] }}</p>
        </l-tooltip>
        <l-icon :class-name="show_next_waypoint && shouldShow ? 'next-waypoint' : 'display-none'" :iconSize="[70, 70]">
          <v-icon :color="hexOpposite(vehicle?.boat_waypoint_color)" size="50">mdi-map-marker</v-icon>
        </l-icon>

      </l-marker>

      <l-polyline class-name="polyline-next-waypoint" :lat-lngs="show_next_waypoint && shouldShow ? [[safeRecord?.[vehicle.fields.wp_latitudeKey], safeRecord?.[vehicle.fields.wp_longitudeKey]],
      getLatLng(safeRecord)] : []" :color="'#002885'"></l-polyline>

    </template>
  </div>

</template>

<script>
import { computed, nextTick, onMounted, ref, watch, watchEffect, onUnmounted } from 'vue';
import { LIcon, LPolyline, LMarker, LTooltip } from '@vue-leaflet/vue-leaflet';
import Icon from './icons/Icon.vue';
import { usePlayMissionStore } from '@/store/playMission';
import L from 'leaflet';
import 'leaflet-textpath'
export default {
  props: ['vehicle_id', 'mission_id', 'show_boats_route', 'show_wind', 'show_next_waypoint', 'show_waypoints'],
  components: {
    LIcon, LPolyline, LMarker, LTooltip, Icon
  },
  setup(props) {

    const store = usePlayMissionStore();
    const mission = computed(() => store.missions.find(m => m.id === props.mission_id));
    const vehicle = computed(() => mission.value?.vehicles.find(v => v.id === props.vehicle_id));

    const P = computed(() => vehicle.value?.P ?? 0);
    const W = computed(() => vehicle.value?.W ?? 0);

    const safeRecord = computed(() => {

      if (!vehicle.value?.records || P.value < 0 || P.value >= vehicle.value.records.length) {
        // console.log(vehicle.value.records, P.value, vehicle.value.records.length)
        return null;
      }
      return vehicle.value.records[P.value];
    });

    const RADIUS = 38;
    const windPosition = computed(() => {
      try {
        if (
          !(props.show_wind &&
            shouldShow.value &&
            safeRecord.value &&
            vehicle.value.fields?.wind_angleKey &&
            vehicle.value.fields?.wind_speedKey &&
            vehicle.value.fields?.headingKey)
        ) return { x: 0, y: 0 };
        const totalDirection = (safeRecord.value[vehicle.value.fields.wind_angleKey] + safeRecord.value[vehicle.value.fields.headingKey]) % 360;

        const angleRad = ((totalDirection - 79.7) * Math.PI) / 180;
        const x = RADIUS * Math.cos(angleRad);
        const y = RADIUS * Math.sin(angleRad);
        return { x: x, y: y, angle: totalDirection };
      } catch (e) {
        console.log(e)
      }

    });





    const getLatLng = (record) => {
      if (!record || !vehicle.value?.fields) return [0, 0];
      const lat = record[vehicle.value.fields.latitudeKey];
      const lng = record[vehicle.value.fields.longitudeKey];
      return lat != null && lng != null ? [lat, lng] : [0, 0];
    };

    const shouldShow = computed(() => {
      if (mission.value.is_loading || !safeRecord.value) return false;
      return mission.value.current_playing_date >= vehicle.value.timestamps[P.value];
    });

    const polylineRef = ref();

    const polylineWaypoints = computed(() => {
      if (vehicle.value.latLngsWaypoints.length == 0) {
        return [];
      }
      const waypoints = vehicle.value.latLngsWaypoints[W.value];
      const nodes = vehicle.value.waypoints[W.value].nodes.slice(1);
      let result = [];
      for (let node of nodes) {
        result.push(waypoints[node])
      }

      if (vehicle.value.waypoints[W.value].is_cyclic && result.length > 0) {
        result.push(result[0]);
      }


      return result;
    });



    watch(polylineWaypoints, async (newVal) => {
      setPolylineWaypointsArrows();
    })

    const setPolylineWaypointsArrows = async () => {
      if (polylineRef.value?.leafletObject) {
        await nextTick()
        const color = vehicle.value.boat_waypoint_color == '' ? '#002885' : vehicle.value.boat_waypoint_color;
        polylineRef.value?.leafletObject.setText('')
        if (vehicle.value.waypoints.length == 0) return;
        if (vehicle.value.waypoints[W.value].is_cyclic) {
          polylineRef.value?.leafletObject.setText(' ►       ', {
            repeat: true,
            center: true,
            offset: 5,
            attributes: { fill: color, 'font-size': '14px' }
          })
        } else {
          polylineRef.value?.leafletObject.setText(' ◄      ► ', {
            repeat: true,
            center: true,
            offset: 5,
            attributes: { fill: color, 'font-size': '14px' }
          })
        }

      }
    }


    let intervalWaypoints = null;
    onMounted(() => {
      setPolylineWaypointsArrows();
      intervalWaypoints = setInterval(() => {
        if (vehicle.value.timestampsWaypoints && mission.value.current_playing_date) {
          vehicle.value.W = findClosestIndex(vehicle.value.timestampsWaypoints, mission.value.current_playing_date);
        }
      }, 1000)
    })

    onUnmounted(() => {
      clearInterval(intervalWaypoints)
    })




    const findClosestIndex = (timestamps, time) => {
      let low = 0;
      let high = timestamps.length - 1;

      while (low <= high) {
        const mid = Math.floor((low + high) / 2);
        if (timestamps[mid] === time) return mid;
        if (timestamps[mid] < time) low = mid + 1;
        else high = mid - 1;
      }

      return Math.max(0, low - 1); // el más cercano anterior o igual
    }


    watchEffect(() => {
      const closing = mission.value?.closing;
      if (closing !== undefined) {
        if (closing) {
          //LÓGICA PARA CERRAR SEGURO
          clearInterval(intervalWaypoints)
          vehicle.value.isClosed = true;
        }
      }
    });

    const getShortLines = (wind) => {
      const amount = wind / 10;
      const integerPart = Math.trunc(amount);
      const decimalPart = amount - integerPart;
      if (decimalPart <= 0.5 && decimalPart > 0) {
        return 1
      } else return 0;
    }

    const hexToRgb = (hex) => {
      hex = hex.replace(/^#/, '');
      let bigint = parseInt(hex, 16);
      let r = (bigint >> 16) & 255;
      let g = (bigint >> 8) & 255;
      let b = bigint & 255;
      return [r, g, b];
    }

    const rgbToHex = (r, g, b) => {
      return '#' + [r, g, b].map(x => {
        let hex = x.toString(16);
        return hex.length === 1 ? '0' + hex : hex;
      }).join('');
    }

    const rgbOpposite = (r, g, b) => {
      return [255 - r, 255 - g, 255 - b];
    }

    const hexOpposite = (hex) => {
      let [r, g, b] = hexToRgb(hex);
      let [rOpp, gOpp, bOpp] = rgbOpposite(r, g, b);
      return rgbToHex(rOpp, gOpp, bOpp);
    }



    const getLargeLines = (wind) => {
      const amount = wind / 10;
      let integerPart = Math.trunc(amount);
      const decimalPart = (amount - integerPart);
      let totalWind = wind;
      while (totalWind >= 50) {
        integerPart -= 5;
        totalWind -= 50;
      }
      if (decimalPart > 0.5) {
        integerPart++;
      }
      return integerPart;
    }

    const getTriangles = (wind) => {
      const amount = wind / 50;
      const integerPart = Math.trunc(amount);
      return integerPart;
    }
    return {
      mission,
      vehicle,
      P,
      getShortLines,
      getLargeLines,
      getTriangles,
      hexOpposite,
      safeRecord,
      windPosition,
      getLatLng,
      polylineWaypoints,
      polylineRef,
      W,
      shouldShow
    }
  },

  errorCaptured(error) {
    console.log(error.message);
  }
}

</script>

<style lang="css">
.wind_svg {
  height: 35px;
  width: 35px;
  position: absolute;
  transform-origin: center;
  pointer-events: none;
}

.wind-card {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wind_svg .wind_svg_velocity_triangle {
  stroke: black;
  fill: black;
}

.wind_svg .wind_svg_velocity_long_line {
  stroke: black;
  fill: black;
}

.wind_svg .wind_svg_velocity_short_line {
  stroke: black;
  fill: black;
}

.waypoints {
  z-index: 100 !important;
}

.polyline-waypoints {
  z-index: 10 !important;
}

.boat {
  z-index: 1000 !important;
}

.next-waypoint {
  z-index: 200 !important;
}

.route {
  z-index: 500 !important;
}

.polyline-next-waypoint {
  z-index: 150 !important;
}

.display-none {
  display: none !important;
}
</style>
